/**
 * External dependencies
 */
import $ from "jquery";

// AOS is only needed on pages that actually hold animated elements, so both the
// library and its stylesheet are pulled in on demand instead of shipping with
// the main bundle.
window.addEventListener("load", async () => {
	if (!document.querySelector("[data-aos]")) {
		return;
	}

	const [{ default: AOS }] = await Promise.all([
		import("aos"),
		import("aos/dist/aos.css"),
	]);

	AOS.init({
		once: false, // animatie meerdere keren toestaan
		mirror: false, // geen animatie bij terugscrollen
		duration: 600, // Standaard duur
		easing: "ease-out-cubic", // Mooiere easing
		offset: 50, // Start animatie iets eerder
		delay: 0, // Standaard delay
		anchorPlacement: "center-bottom",
	});

	AOS.refreshHard();
});

/*
 * Internal dependencies
 */
import "./modules/accordion";
import "./modules/sliders";
import "./modules/tab";
import "./modules/dropdown";
import "./modules/search";
import "./modules/nav-toggle";
import "./modules/lottie";
import "./modules/language-switcher";
import "./modules/animations";

// Load more news functionality
const initLoadMoreNews = () => {
	let currentPage = 1;
	const loadMoreBtn = document.querySelector("#load-more-news");
	const container = document.querySelector("#news-container");

	if (!loadMoreBtn || !container) return;

	loadMoreBtn.addEventListener("click", () => {
		currentPage++;

		fetch(`/wp-json/eurorope/v1/news?page=${currentPage}`)
			.then((res) => {
				if (!res.ok) throw new Error("Network response was not ok");
				return res.json();
			})
			.then((data) => {
				if (!data.html.trim()) {
					loadMoreBtn.style.display = "none";
					return;
				}
				container.insertAdjacentHTML("beforeend", data.html);

				// Hide button if no more posts
				if (!data.has_more) {
					loadMoreBtn.style.display = "none";
				}
			})
			.catch((err) => console.error(err));
	});
};

// Initialize load more news
initLoadMoreNews();
